// Bir satışın kalemlerinin GERÇEK (indirim uygulanmış) birim fiyatlarını TEK bir yerden hesaplar.
// Amaç: yazdırılan fiş, ekrandaki "Fiş Detayı" modalı, "Fiş Düzenleme" modalı ve "Değişim/İade"
// ekranı AYNI birim fiyatları göstersin; her ekran kendi hesabını yapmasın.
//
// Kural:
//  - Taban = kalemin satış anında saklanmış indirimli birim fiyatı (total_price / discounted_unit_price).
//  - Hedef satır toplamı = MÜŞTERİNİN MALA ÖDEDİĞİ net tutar = sales.subtotal - sales.discount.
//    (sales.subtotal kalem indirimlerini zaten düşmüştür; sales.discount ek sepet indirimidir.
//     Hurda ve ödeme yöntemi bu tutara DAHİL DEĞİLDİR — hurda bir ödeme aracıdır, indirim değil.)
//  - Saklı satır toplamı hedefe (tolerans içinde) eşitse → saklı değerler DOĞRUDAN kullanılır
//    (temiz satışların %100'ü; hiçbir şey değişmez). Yazdırılan fiş de bunu yapar.
//  - Eşit değilse (sepet indirimi kalemlere paylaştırılmamış / bozuk eski kayıt) → saklı değerler,
//    satır toplamı = hedef olacak biçimde ORANLA düzeltilir. Kalemler arası indirim yapısı korunur.
//  - subtotal güvenilmezse (0 / eksik / saçma) saklı satır toplamına düşülür → yine hiçbir şey değişmez.
export function computeSaleItemPricing(sale, adjustments = []) {
  const items = Array.isArray(sale?.items) ? sale.items : [];

  const qtyOf = (it) => Math.abs(Number(it?.quantity) || 1);

  // Kalemin satış anında saklanmış indirimli birim fiyatı
  const storedUnit = (it) => {
    const tp = Number(it?.total_price);
    if (!Number.isNaN(tp) && tp !== 0) return Math.abs(tp) / qtyOf(it);
    return Number(it?.discounted_unit_price ?? it?.unit_price ?? 0);
  };
  const storedItemSum = items.reduce((s, it) => s + storedUnit(it) * qtyOf(it), 0);

  // Müşterinin mala ödediği net tutar
  const subtotal = Math.abs(Number(sale?.subtotal) || 0);
  const discount = Math.max(0, Number(sale?.discount) || 0);
  let goodsTotal = subtotal - discount;

  // subtotal güvenilmez → saklı satır toplamı (hiçbir şey değişmez)
  if (!(goodsTotal > 0) || storedItemSum <= 0 || goodsTotal > storedItemSum * 3) {
    goodsTotal = storedItemSum;
  }

  const tolerance = Math.max(1, goodsTotal * 0.005);
  const reconciles = storedItemSum > 0 && Math.abs(storedItemSum - goodsTotal) <= tolerance;

  // Örtüşmüyorsa: saklı değerleri, satır toplamı = goodsTotal olacak şekilde oranla düzelt
  const ratio = (!reconciles && storedItemSum > 0 && goodsTotal > 0) ? (goodsTotal / storedItemSum) : 1;

  const itemUnitPrice = (it) => storedUnit(it) * ratio;

  // Fark (adjustment) kalemleri kendi discountShare'iyle nettir; kaleme özel oran uygulanmaz
  // (Fiş Detayı modalındaki fark kalemi gösterimiyle birebir aynı mantık).
  const adjAmount = (adj) => {
    const gross = Number(adj?.amount ?? adj?.refund_amount ?? adj?.original_amount) || 0;
    const share = Number(adj?.discountShare || 0);
    return gross - (share > 0 ? share : 0);
  };

  return { reconciles, ratio, goodsTotal, storedItemSum, itemUnitPrice, adjAmount };
}
